module.exports = __webpack_public_path__ + "img/section1.d9529515.png";